import styled from "@emotion/styled";
import searchIcon from "../../icons/search-icon-blue.svg";

export const HeaderStyled = styled.div`
  position: sticky;
  top: 0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 0 15px;
  height: 64px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  /* "futura-pt" comes from BKV's Typekit kit (real 300/400/500/600); the bundled
     "Futura PT Book" is a single 400 file and is only the fallback */
  font-family: "futura-pt", "Futura PT Book", sans-serif;
  .logo {
    width: 120px;
    height: 48px;
    cursor: pointer;
  }

  a {
    text-decoration: none;
    color: #09507f;
    text-transform: uppercase;
    font-size: 15px;
  }

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(
      103deg,
      #ffd27d 0%,
      #87c674 15%,
      #139e87 62%,
      #09507f 100%
    );
    z-index: 9999;
  }

  @media (max-width: 992px) {
    .logo {
      width: 105px;
      height: 42px;
    }
  }

  @media (max-width: 768px) {
    height: 64px;
    padding: 0 15px;
    .logo {
      width: 90px;
      height: 36px;
    }
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* parent .container ladder 1654/1390/1150/unset + nav.main-nav gap ladder 30/15/10/8
     - this is the nav -> phone/button gap */
  gap: 30px;
  width: 100%;
  max-width: 1654px;
  padding: 0 15px;
  /* parent's .container is border-box: max-width includes the padding */
  box-sizing: border-box;
  @media (max-width: 1720px) {
    gap: 15px;
    max-width: 1390px;
  }
  @media (max-width: 1440px) {
    gap: 10px;
    max-width: 1150px;
  }
  @media (max-width: 1200px) {
    gap: 8px;
    max-width: unset;
    padding: 0 20px;
  }
  img:hover {
    cursor: pointer;
  }
`;

export const HeaderTitleItems = styled.div`
  display: flex;
  /* parent ul.navbar-nav gap ladder: 20 / 10 / 15 / 10 */
  gap: 20px;
  justify-content: space-evenly;
  height: 100%;
  /* parent ul.navbar-nav carries margin-right:85px at base only */
  margin-right: 85px;
  /* parent's nav.main-nav is margin-left:auto, so the cluster hugs the CTA */
  margin-left: auto;
  @media (max-width: 1720px) {
    gap: 10px;
    margin-right: 0;
  }
  @media (max-width: 1440px) {
    gap: 15px;
  }
  @media (max-width: 1200px) {
    gap: 10px;
  }
`;

export const HeaderTitleItem = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0;
  a {
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    /* parent .navbar-nav > li > a: 15px + 16px base, 15px 5px + 15px @1440 */
    padding: 15px;
    line-height: 29px;
    font-size: 16px;
    text-underline-offset: 5px;
    @media (max-width: 1440px) {
      padding: 15px 5px;
      font-size: 15px;
    }
  }
  a:hover {
    text-decoration: underline !important;
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  /* anchors the absolutely-positioned search box so it can grow leftward
     without reflowing the nav/CTA (parent anchors it in nav.main-nav) */
  position: relative;
  /* parent nav.main-nav carries padding-right:55px, which is what sets the
     button's 77px inset from the container edge (55 + 15 container + 7 btn margin) */
  padding-right: 55px;
  @media (max-width: 992px) {
    padding-right: 0;
  }
  /* same gap ladder as nav.main-nav */
  gap: 30px;
  @media (max-width: 1720px) {
    gap: 15px;
  }
  @media (max-width: 1440px) {
    gap: 10px;
  }
  @media (max-width: 1200px) {
    gap: 8px;
  }
  /* phone CTA - parent's .main-nav__cta--phone: 16px/29px weight 500, pointer */
  a {
    font-size: 16px;
    line-height: 29px;
    font-weight: 500;
    cursor: pointer;
    /* parent .main-nav__cta is margin:0 7px */
    margin: 0 7px;
  }
  a:hover {
    color: #00b49d;
  }
  /* scoped to the direct child so this cannot reach the search button that sits
     nested inside its own form. An unscoped descendant button rule here wiped the
     search icon on hover (the background shorthand reset background-image) and
     applied the CTA scale animation to it. */
  > button {
    border-radius: 27px;
    transition: all 0.1s ease-in-out;
    border: 3px solid #ffd27d;
    background: #ffd27d;
    padding: 9px 38px;
    min-width: 190px;
    margin: 0 7px;
    box-sizing: border-box;
    font-family: "futura-pt", sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 23px;
    cursor: pointer;
    /* Parent's real ladder. Measured on bkvenergy.com with a fresh load at every width:
       the CTA is 47px tall (9px/9px block padding + 23px line-height + 6px border) at
       375, 768, 992, 1200, 1440, 1920 - it never shrinks.
       Why the authored <=1200 block (font-size 12px; line-height 16px; padding 7px 10px)
       does NOT apply: @media (max-width:1200px) .button is (0,1,0) while
       .main-nav .button { font-size: 15px } is (0,2,0), so the larger base wins and only
       the parts of the <=1200 rule that are more specific (min-width, 0,3,0) take effect.
       Carrying that block over is what made our CTA collapse to 36px below 1200. */
    @media (max-width: 1720px) {
      padding-inline: 13px;
    }
    @media (max-width: 1200px) {
      min-width: unset;
    }
    /* MUI <Typography> renders a <p> with .MuiTypography-body1 (font-size:0.8rem=12.8px);
       inheriting from the button outranks it and keeps the ladder in one place */
    p {
      margin: 0;
      font-family: inherit;
      font-size: inherit;
      font-weight: 600;
      line-height: inherit;
      text-transform: uppercase;
    }
    &:hover {
      animation: scale 0.2s ease-in-out;
      background: transparent;
    }
    @keyframes scale {
      from {
        transform: scale(1);
      }
      to {
        transform: scale(1.1);
      }
    }
  }

  /* same boundary as the nav collapse so the CTA keeps parent's margin: 0 7px */
  @media (max-width: 992px) {
    > button {
      margin-left: 0;
    }
  }
`;

/* Search control mirroring bkvenergy.com's header search.
   Every value below is taken from the parent's own author CSS, which is:
     form.search-form    position absolute; right 0; top 50%; translateY(-50%); transition width .3s
     .search-field       border 0; width 40px; height 40px; radius 31px; opacity 0; position relative;
                         z-index 2; cursor pointer; color rgb(9,78,128)
     .search-field.search-input-opened
                         padding 14px 45px 15px 26px; background #fff; border 1px solid rgb(23,180,157);
                         width 424px; opacity 1; cursor default; font-size 18px
     .search-field::placeholder
                         color rgb(9,78,128); text-transform uppercase; opacity 0, 1 once open
     input[type=submit]  position absolute; right 5px; top 0; bottom 0; 40x40; radius 31px;
                         background-image <own filled svg>, centred; cursor pointer; z-index 5
   The submit anchors to the FIELD (the field is position:relative), which is why the field
   reserves 45px of right padding once open - the glyph sits inside the pill.
   The form is position:absolute, so opening reflows nothing.
   On the parent the field is never removed: it stays in the DOM at opacity 0 and only its
   width/opacity change, which is what makes the 0.3s width transition read correctly.
   The mobile drawer is the parent's <=992px case: field permanently open, 350px (100% <=576). */
export const SearchBoxStyled = styled.form`
  display: block;
  box-sizing: border-box;
  ${({ $wide }) =>
    $wide
      ? `width: 100%; margin-top: 8px;`
      : `
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: width 0.3s;
    z-index: 20;
  `}
`;

export const SearchField = styled.input`
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  z-index: 2;
  width: ${({ $open, $wide }) => ($open ? ($wide ? "100%" : "424px") : "40px")};
  max-width: 100%;
  height: 40px;
  margin: 0;
  padding: ${({ $open }) => ($open ? "14px 45px 15px 26px" : "0")};
  border: ${({ $open }) => ($open ? "1px solid #17b49d" : "0")};
  border-radius: 31px;
  background-color: ${({ $open }) => ($open ? "#ffffff" : "transparent")};
  color: #094e80;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  cursor: ${({ $open }) => ($open ? "default" : "pointer")};
  transition: 0.3s;
  outline: none;
  font-family: "futura-pt", sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: normal;
  text-transform: none;
  &::placeholder {
    color: #094e80;
    text-transform: uppercase;
    letter-spacing: normal;
    opacity: ${({ $open }) => ($open ? 1 : 0)};
    transition: opacity 0.3s;
  }
  &:focus {
    border-color: #17b49d;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 20px;
  }
  /* parent's own <=992px (drawer) block: the field there is a fixed 350px, and it
     carries its own placeholder treatment - 14px, rgb(9,80,127) - not the desktop one.
     <=576px the parent narrows the opened field to 235px. */
  ${({ $wide }) =>
    $wide
      ? `
  @media (max-width: 992px) {
    width: 350px;
    &::placeholder {
      opacity: 1;
      font-size: 14px;
      color: #09507f;
    }
  }
  @media (max-width: 576px) {
    width: 235px;
  }
  `
      : ""}
`;

/* Doubles the class specificity so it outranks RightSection's descendant
   button rule (0,2,0 beats 0,1,1). The && selector is intentional.
   Mirrors bkvenergy.com's input.search-submit: 40x40, radius 31px, pinned to the
   form's right edge (on the parent it never moves between states - the field grows
   leftward underneath it), glyph painted as a centred background-image.
   z-index 5 keeps it above the field (z-index 2) while the field is transparent. */
export const SearchIconBtn = styled.button`
  /* reset CTA styling (border/bg/padding/min-width) applied by RightSection */
  && {
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border: 0;
    padding: 0;
    margin: 0;
    min-width: unset;
    width: 40px;
    height: 40px;
    border-radius: 31px;
    display: block;
    cursor: pointer;
    /* parent's input.search-submit declares transition:all with 0s duration and
       has no visual hover change - mirrored exactly so the two read identically */
    transition: all;
    z-index: 5;
    background-color: transparent;
    background-image: url(${searchIcon});
    background-repeat: no-repeat;
    background-position: 50% 50%;
    &:focus-visible {
      outline: 2px solid #17b49d;
      outline-offset: 2px;
    }
  }
`;

export const Drawer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  /* parent's ul.sub-menu sizes to its content (293-477px tall) and never scrolls */
  height: auto;
  max-height: 477px;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: top 0.3s ease-out 0s, opacity 0.3s ease-out 0s;
  z-index: 10;
  overflow: visible;
  /* the drawer renders outside #header, so it must declare the font itself */
  font-family: "futura-pt", "Futura PT Book", sans-serif;
  &.open {
    top: 64px;
    transition: all 0.3s ease-out 0s;
    pointer-events: auto;
    opacity: 1;
    visibility: visible;
  }

  &.close {
    top: 128px;
    opacity: 0;
    visibility: hidden;
  }
`;

export const DrawerContent = styled.div`
  /* parent ul.sub-menu = padding:48px 0, and its heading text sits 9px lower still
     (panel top 64 -> heading text 121) */
  padding: 57px 0 40px;
  display: flex;
  justify-content: center;
  gap: 200px;
  align-items: flex-start;
  /* column heading - bkvenergy.com renders these as LarkenMedium 16px/29px w500
     #00b49d underlined (the <a>/<strong>), NOT the 20px grey body paragraph */
  .link-title {
    font-family: "Larken DEMO medium", "Larken DEMO", Georgia, serif;
    color: #00b49d;
    font-size: 16px;
    line-height: 29px;
    text-decoration: underline;
    text-underline-offset: 3px;
    font-weight: 500;
    text-transform: none;
    /* parent: heading text y=121 -> first item y=159 (measured gap 9px) */
    margin: 0 0 7px;
  }
  .link-title:hover {
    color: #09507f;
  }
  a {
    text-decoration: none;
    color: #09507f;
    text-transform: uppercase;
    font-size: 16px;
    line-height: 26px;
    font-family: inherit;
  }
  a:hover {
    color: #00b49d;
  }
`;

export const DrawerLink = styled.div`
  /* parent item pitch = 46px (26px line-height + 20px) - must be per-item margin,
     not flex gap, or it also inflates the heading -> first-item gap */
  margin-bottom: 20px;
`;

export const DrawerLinks = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileDrawerSection = styled.div`
    width: 100%;
    height: calc( 100vh - 64px);
    background: #fff;
    padding: 8%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    z-index: 2;
    position: absolute;
    top: 64px;
    right: 0;

    &.open {
      visibility: visible;
      opacity: 1;
      transition: visibility 0s, opacity 0.5s linear;
    }

    &.close {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0.6s, opacity 0.5s linear;
    }
`;

export const MobileDrawerTitle = styled.div`
    font-size: 18px;
    padding: 15px 5px;
    background:#fff;
    color: #09507f;
    font-family: "futura-pt", "Futura PT Book", sans-serif;
    display: flex;
    justify-content: space-between;
    padding-right: 50px;
`

export const Accordion = styled.div`
    &.accordion-open {
      visibility: visible;
      height: 100%;
      opacity: 1;
      transition:height 0.6s, opacity 0.6s linear;
    }

    &.accordion-close {
      visibility: hidden;
      height: 0;
      opacity: 0;
      transition: height 0.6s, visibility 0.3s, opacity 1s linear;
    }
`

export const AccordionLink = styled.div`
  /* 22px line-box + 24px = 46px row pitch (matches parent's menu) */
  margin-bottom: 24px;
`

export const AccordionLinks = styled.div`
  font-family: "futura-pt", "Futura PT Book", sans-serif;
  /* column heading - same treatment as the desktop drawer (LarkenMedium 16px/29px w500
     #00b49d underlined) so both breakpoints read as one component */
  .link-title {
    font-family: "Larken DEMO medium", "Larken DEMO", Georgia, serif;
    color: #00b49d;
    font-size: 16px;
    line-height: 29px;
    text-decoration: underline;
    text-underline-offset: 3px;
    font-weight: 500;
    text-transform: none;
    /* 29px line-box + 17px = 46px heading -> first item (verified on mobile 375) */
    margin-bottom: 17px;
  }
  .link-title:hover {
    color: #09507f;
  }
  a {
    text-decoration: none;
    color: #09507f;
    text-transform: uppercase;
    font-family: "futura-pt", "Futura PT Book", sans-serif;
    font-size: 16px;
    line-height: 22px;
    display: block;
  }
  a:hover {
    color: #00b49d;
  }
`
